module.exports = __webpack_public_path__ + "img/header-img-v8.ef70f4ba.jpg";